<ng-container>
  <app-data-table [columns]="cols" [data]="system" [isCardView]="false" (onPresentView)="getSystem()" [url]="'`/master/incubator/'"
     [isDeletable]="'/master/incubator' | hasPermission: 'Delete'"  [showAddButton]="'/master/incubator' | hasPermission: 'Add'" [showActions]="canEditSetup" [isEditable]="'/master/incubator' | hasPermission: 'Edit'"  [title]="title" (onAdd)="addSystem()" (editEventRow)="updateSystem($event)" [isView]="'/master/incubator' | hasPermission: 'View'" (viewEventRow)="viewSystem($event)"
    (deleteEventRow)="showDeletePopup($event)" (onLazyLoadData)="getSystem($event)" [totalRecords]="totalRecords">
  </app-data-table>
</ng-container>

<p-dialog header="Create Incubator" [(visible)]="showDialog" [modal]="true" [style]="{width: '600px' , height:'auto'}"
  [closable]="true" [dismissableMask]="true" [maximizable]="true">

  <form [formGroup]="systemForm" (ngSubmit)="onSubmitadd()" class="form-wrapper">
    <div class="mt-4 mb-3">
      <label class="form-label"><b>Name</b></label>
      <input type="text" class="form-control" formControlName="name" maxlength="100">
      <div *ngIf="systemForm.get('name')?.touched">
          <small class="text-danger" *ngIf="systemForm.get('name')?.hasError('required')">
            Name is required.
          </small>
          <small class="text-danger" *ngIf="systemForm.get('name')?.hasError('pattern')">
            Name must be alphanumeric and can include spaces and '&' only.
          </small>
        </div>
    </div>
    <div class="mt-4 mb-3">
      <label for="section"><b>Scheme</b></label>
      <p-multiSelect [options]="schemes" optionLabel="name" optionValue="id" formControlName="selectedOptions"
        placeholder="Select options" display="chip" class="w-100" appendTo="body"></p-multiSelect>
      <div class="text-danger mt-1"
        *ngIf="systemForm.get('selectedOptions')?.touched && systemForm.get('selectedOptions')?.hasError('required')">
        Scheme is required.
      </div>
    </div>
    <div class="mt-4 mb-3">
      <label for="section"><b>Description</b></label>
      <textarea class="form-control" formControlName="description" rows="4"></textarea>
      <div *ngIf="systemForm.get('description')?.touched">
          <small class="text-danger" *ngIf="systemForm.get('description')?.hasError('required')">
            Description is required.
          </small>
          <small class="text-danger" *ngIf="systemForm.get('description')?.hasError('pattern')">
            Description must be alphanumeric and can include spaces and '&' only.
          </small>
        </div>
    </div>


    <div class="d-flex justify-content-end mt-3 btn-wrapper">
      <!-- <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button> -->
      <button type="submit" class="btn btn-primary me-2" [disabled]="systemForm.invalid">Submit</button>
    </div>
  </form>
</p-dialog>


<p-dialog  [header]="viewMode ? 'View Incubator' : 'Update Incubator'" [(visible)]="isUpdatedialog" [modal]="true" [maximizable]="true" [style]="{width: '600px' , height:'auto'}" [closable]="true" [dismissableMask]="true"
  [contentStyle]="{'display': 'flex', 'flexDirection': 'column', 'height': '100%' , 'justify-content' : 'space-between'}">

  <form [formGroup]="systemForm" (ngSubmit)="onSubmitEq()" class="form-wrapper">
    <div class="mt-4 mb-3">
      <label class="form-label"><b>Name</b></label>
      <input type="text" class="form-control" formControlName="name" maxlength="100">
     <div *ngIf="systemForm.get('name')?.touched">
          <small class="text-danger" *ngIf="systemForm.get('name')?.hasError('required')">
            Name is required.
          </small>
          <small class="text-danger" *ngIf="systemForm.get('name')?.hasError('pattern')">
            Name must be alphanumeric and can include spaces and '&' only.
          </small>
        </div>
    </div>
    <div class="mt-4 mb-3">
      <label for="section"><b>Scheme</b></label>
      <p-multiSelect [options]="schemes" optionLabel="name" optionValue="id" formControlName="selectedOptions"
        placeholder="Select options" display="chip" class="w-100" appendTo="body"></p-multiSelect>
      <div class="text-danger mt-1"
        *ngIf="systemForm.get('selectedOptions')?.touched && systemForm.get('selectedOptions')?.hasError('required')">
        Scheme is required.
      </div>
    </div>
    <div class="mt-4 mt-3">
      <label for="section"><b>Description</b></label>
      <textarea class="form-control" formControlName="description" rows="4"></textarea>
      <div *ngIf="systemForm.get('description')?.touched">
          <small class="text-danger" *ngIf="systemForm.get('description')?.hasError('required')">
            Description is required.
          </small>
          <small class="text-danger" *ngIf="systemForm.get('description')?.hasError('pattern')">
            Description must be alphanumeric and can include spaces and '&' only.
          </small>
        </div>
    </div>

    <div class="d-flex justify-content-end mt-3 btn-wrapper">
      <!-- <button type="button" class="btn btn-secondary" (click)="onCancel()">Cancel</button> -->
      <button type="submit" class="btn btn-primary " *ngIf="!viewMode" [disabled]="systemForm.invalid || systemForm.pristine">
        Submit
      </button>

    </div>
  </form>
</p-dialog>

<p-dialog header="Delete Incubator" [modal]="true" [(visible)]="showDeleteDialog" [style]="{ width: '30rem' }" [maximizable]="true">
  <div class="delete-dialog mt-3">
     <i class="pi pi-trash text-danger custom-delete-icon"></i>
    <span>Are you sure , you want to delete Incubator ?</span>
    <p-button label="Delete" icon="pi pi-trash" severity="danger" [outlined]="true" (click)="deleteSystem()" class="mt-2">
    </p-button>
  </div>
</p-dialog>